<script>
import NavBar from '@/components/navbar/NavBar'
import SubNavBar from '@/components/navbar/SubNavBar'
import FooterView from '@/components/Footer'
export default {
  name: 'app',
  components: {
    NavBar,
    SubNavBar,
    FooterView,
  },
}
</script>
<template>
  <div id="app">
    <nav-bar/>
    <sub-nav-bar/>
    <div class="separator_thin"></div>
    <div class="header-discount">
      Sconto del 20% su tutti i kayak presenti in negozio in pronta consegna
    </div>
    <div class="separator_thin"></div>
    <router-view/>
    <footer-view/>
  </div>
</template>